import { Component, Input } from '@angular/core';

@Component({
  selector: 'md-risk-button',
  template: require('./risk-button.component.html'),
  styles: [require('./risk-button.component.scss')]
})

export class RiskButtonComponent {
  @Input() option;
}
